/** Ant Design Vue tokens that carry the AD168 v2 look (see ad168-app-v2/src/index.css) */
import { theme } from 'ant-design-vue';

export const themeConfig = {
    algorithm: theme.defaultAlgorithm,
    token: {
        colorPrimary: '#DB0E00',
        colorInfo: '#2a78d6',
        colorSuccess: '#1f8a4c',
        colorWarning: '#d98a00',
        colorError: '#c4151c',
        colorLink: '#2a78d6',
        colorTextBase: '#1c1a17',
        colorBgBase: '#ffffff',
        colorBgLayout: '#faf9f6',
        colorBorder: '#e6e3dc',
        colorBorderSecondary: '#efede7',
        borderRadius: 10,
        borderRadiusLG: 14,
        borderRadiusSM: 8,
        fontFamily: "'Geist Variable', ui-sans-serif, system-ui, -apple-system, 'Segoe UI', sans-serif",
        fontSize: 14,
        controlHeight: 36,
        boxShadow: '0 8px 30px rgba(30, 24, 12, 0.12), 0 2px 6px rgba(30, 24, 12, 0.06)',
        boxShadowSecondary: '0 8px 30px rgba(30, 24, 12, 0.12), 0 2px 6px rgba(30, 24, 12, 0.06)'
    },
    components: {
        Button: { primaryShadow: 'none', defaultShadow: 'none', fontWeight: 500 },
        Card: { paddingLG: 20, headerFontSize: 15 },
        Table: {
            headerBg: '#f6f4ef',
            headerColor: '#6b665c',
            headerSplitColor: 'transparent',
            rowHoverBg: '#f6f4ef',
            borderColor: '#efede7',
            cellPaddingBlock: 12
        },
        Menu: {
            itemSelectedBg: '#efede7',
            itemSelectedColor: '#1c1a17',
            itemHoverBg: '#f3f1ec',
            itemBorderRadius: 8,
            itemHeight: 38,
            activeBarBorderWidth: 0
        },
        Layout: { siderBg: '#f6f4ef', bodyBg: '#faf9f6' },
        Input: { activeShadow: '0 0 0 3px rgba(219, 14, 0, 0.12)' },
        Select: { optionSelectedBg: '#efede7' },
        Tag: { defaultBg: '#f3f1ec' }
    }
};
